import { usModelOfAtomsChecker, webPartsPositionFilter } from 'src/logic'
import { I18NText, Position, State, StateObj, WebPartsObj } from 'src/types'
import { SelectCardWithConfirmObject } from 'src/Components/Domain/SelectCardWithConfirm'
import { APL_UR002_PLUS_PRODUCT_NUMBER } from '../constants/baseModel'

const getTannerConfirmColors = (t: I18NText, tannerValue: string) => {
  switch (tannerValue) {
    case 'europeanSteer':
      return t.DISPATCH_EUROPEAN_LEATHER_COLOR_OBJECTS.catchFace
    case 'northSteer':
      return t.DISPATCH_NORTH_LEATHER_COLOR_OBJECTS.catchFace
    case 'steer':
    case 'nineStates':
      return t.DISPATCH_STEER_LEATHER_COLOR_OBJECTS.catchFace
    case 'usSteer':
      return t.DISPATCH_STEER_LEATHER_COLOR_OBJECTS.catchFace
    default:
      return []
  }
}

export const tannerObjectWithConfirmSwitcher = (t: I18NText, state: State): SelectCardWithConfirmObject[] =>
  tannerObjectSwitcher(t, state).map((obj) => ({
    ...obj,
    confirmDescription: t.CAUTION_TANNER,
    confirmColors: getTannerConfirmColors(t, obj.value)
  }))

export const tannerObjectSwitcher = (t: I18NText, state: State): StateObj[] => {
  switch (state.kinds?.value) {
    case 'hard':
      if (usModelOfAtomsChecker(state.baseModel?.productNumber)) {
        return t.TANNER_OBJECTS_US
      }
      return t.TANNER_OBJECTS
    case 'soft':
      return t.TANNER_OBJECTS.filter((t) => t.value !== 'europeanSteer')
    default:
      return []
  }
}

export const dominantArmObjectSwitcher = (isCatcher: boolean, t: I18NText): StateObj[] => {
  // return isCatcher ? t.DOMINANT_ARM_OBJECTS.filter((x) => x.value === 'rightThrow') : t.DOMINANT_ARM_OBJECTS
  return t.DOMINANT_ARM_OBJECTS
}

export const fingerGuardTypeObjectSwitcher = (position: Position, t: I18NText, backStyle?: string): StateObj[] => {
  switch (position) {
    case 'outfielder':
      return t.FINGER_GUARD_TYPE_FOR_OUTFIELDER_OBJECTS
    case 'first':
      return t.FINGER_GUARD_TYPES_FOR_FIRST_BASEMAN
    case 'catcher':
      return t.FINGER_GUARD_TYPE_OBJECTS
    case 'infielder':
      return t.FINGER_GUARD_TYPE_ALL_OBJECTS
    case 'pitcher':
      switch (backStyle) {
        case 'beltBackStyle': // グラブ
          return t.FINGER_GUARD_TYPE_ALL_OBJECTS
        case 'firstBackStyle':
        case 'crownBackStyle':
          return t.FINGER_GUARD_TYPE_ALL_OBJECTS.filter((o) => ['indexCover', 'none'].includes(o.value))
      }
      break
    default:
      return t.FINGER_GUARD_TYPE_OBJECTS
  }
}

export const atomsFlagGenerator = (
  state: State,
  position: Position
): {
  isCatcher: boolean
  isDefaultSize: boolean
  isLeftThrow: boolean
  isTannerSelected: boolean
  isCatcherAndOtherThanAplSeries: boolean
} => {
  const isCatcher = position === 'catcher'
  const isDefaultSize = state.size.value === 'default'
  const isLeftThrow = state.dominantArm.value === 'leftThrow'
  const isTannerSelected = state.tanner?.value !== 'unselected'
  const isCatcherAndOtherThanAplSeries = isCatcher && state.baseModel.productNumber !== APL_UR002_PLUS_PRODUCT_NUMBER
  return {
    isCatcher,
    isDefaultSize,
    isLeftThrow,
    isTannerSelected,
    isCatcherAndOtherThanAplSeries
  }
}

export const baseCautionGenerator = (partsKey: string, t: I18NText): string => {
  switch (partsKey) {
    case 'tanner':
      return t.CAUTION_TANNER
    case 'dominantArm':
      return t.CAUTION_DOMINANT_ARM
    case 'size':
      return t.CAUTION_SIZE
    case 'moldingOrder':
      return t.CAUTION_MOLDING_ORDER
  }
}

export const webPartsFilter = (productNumber: string, position: Position, webParts: WebPartsObj[]) => {
  const isYouthModel = ['AGL-1001', 'AGL-1004', 'AGL-1006'].includes(productNumber)
  return isYouthModel ? webParts.filter((w) => w.isYouth) : webPartsPositionFilter(webParts, position)
}
